import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Root from './root';
import Login from './login';
import Create from './create';
import { CLIENT_PATH } from '../constants';

export default () => (
    <Switch>
        <Route path={`${CLIENT_PATH}/signup`} component={Create} />
        <Route path={`${CLIENT_PATH}/login`} component={Login} />
        <Route path={`${CLIENT_PATH}`} component={Root} />
        <Route component={Login} />
    </Switch>
);



// WEBPACK FOOTER //
// ./src/client/index.tsx